import {
  InventoryPurchasePriceCurrencyOptions,
  InventorySellingPriceCurrencyOptions,
  InventoryEstimatedSellingPriceCurrencyOptions,
} from '../types/pocketbase-types';

export const hebrewCollator = new Intl.Collator('he', { sensitivity: 'base' });

// Original function for ILS-only columns
export function formatCurrency(value: number): string {
  // Pocketbase sets undefined values to 0, so we need to make sure that items without prices don't show a number
  if (value === null || value === undefined || value === 0) return '';

  return new Intl.NumberFormat('he-IL', {
    style: 'currency',
    currency: 'ILS',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value);
}

// New function for multi-currency columns
export function formatCurrencyWithType(
  value: number,
  currency:
    | InventoryPurchasePriceCurrencyOptions
    | InventorySellingPriceCurrencyOptions
    | InventoryEstimatedSellingPriceCurrencyOptions
    | undefined
    | null = InventoryPurchasePriceCurrencyOptions.ILS
): string {
  if (value === null || value === undefined || value === 0) return '';

  return new Intl.NumberFormat('he-IL', {
    style: 'currency',
    currency: currency || InventoryPurchasePriceCurrencyOptions.ILS,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value);
}

export const formatDate = (dateString: string) => {
  // Ensure
  if (!dateString || dateString === undefined) return '';

  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear().toString().slice(-2);
  return `${day}/${month}/${year}`;
};
